import { CommonModule } from '@angular/common'
import { Component } from '@angular/core'
import { SettingsNavComponent } from '../nav-components/settings-nav/settings-nav.component'

@Component({
  selector: 'settings-extended-nav',
  standalone: true,
  imports: [CommonModule, SettingsNavComponent],
  template: ` <settings-nav></settings-nav> `,
})
export class SettingsExtendedNavComponent {}
